<template>
  <div class="MyAccountSideBar" id="scroll">
    <UserProfile></UserProfile>

    <div class="menu-item-list">
      <div
        class="top-margin-25"
        v-for="(menu, menu_index) in menu_list"
        :key="menu_index"
      >
        <span
          class="flex"
          @click="selectMenu(menu.title)"
          :style="[
            menu.title == 'Change Password' &&
            userProfile &&
            userProfile.utm_medium != 'EMAIL'
              ? { display: 'none' }
              : {},
          ]"
        >
          <img :src="menu.icon" width="20" class="right-margin-20" />
          <div
            class="title"
            :class="[myAccountActiveState == menu.title ? 'active-menu' : '']"
          >
            {{ menu.title }}
          </div>
        </span>
      </div>

      <div v-if="hasPublisherPlan">
        <hr style="margin:20px 0px" />
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item name="1">
            <template #title>
              <div class="download-title">
                <div
                  ref="certificateContainer"
                  style="position: absolute; left: -9999px; width: 100vw;"
                >
                  <PublisherCertificate
                    ref="certificate"
                    :certificateData="certificateData"
                  />
                </div>
                <div
                  :style="{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor:
                      certificateData &&
                      certificateData.is_eligible_for_download
                        ? 'pointer'
                        : 'not-allowed',
                    opacity:
                      certificateData &&
                      certificateData.is_eligible_for_download
                        ? 1
                        : 0.5,
                  }"
                  @click="handleDownloadClick"
                >
                  <span
                    style="margin-right: 5px; font-size: 18px; font-weight: 600;"
                  >
                    Certificate
                  </span>
                  <span>
                    <img
                      src="../assets/images/Download Icon (1).svg"
                      alt=""
                      style="width: 18px;"
                    />
                  </span>
                </div>
              </div>
            </template>
            <div
              v-if="
                !certificateData || !certificateData.is_eligible_for_download
              "
              class="font-06rem capitalize font-weight-600 text-center download-collapse-section"
            >
              You can Download your <br />
              NISM certificate after completion <br />of your 30 Days Track
              record
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div
      v-if="isPdfDownloading"
      style="position: fixed;
    bottom: 0px;
    font-size: 12px;
    font-weight: 500;
    width: 248px;
    background-color: #ffff;
    padding: 8px;
"
    >
      Downloading . . .
    </div>

    <div id="pdf-content" ref="pdfContent" class="pdf-style">
      <!-- Page 1 -->
      <div class="page">
        <img :src="stockAntsLogo" alt="Logo" class="logo" />
        <h1 class="font-weight-600">Master Service Agreement</h1>
        <p>
          This Master Service Agreement is executed on 1st May’2024. By &
          Between
        </p>
        <ul>
          <li>
            <span class="font-weight-600">{{ userProfile.full_name }},</span>
            with SEBI Registered Number
            {{
              userProfile.sebi_regi_number ? userProfile.sebi_regi_number : "-"
            }}, registered address at
            <span class="lowercase">{{
              userProfile.address ? userProfile.address : ""
            }}</span>
            hereinafter referred to as
            <span class="font-weight-600">
              “SEBI Expert”.
            </span>
            <br />
            AND
          </li>
          <li>
            <span class="font-weight-600"> TechVest LLP,</span> a limited liability partnership incorporated under the provisions of the Limited Liability Partnership Act, 2008 having its registered office at 402. Tower 3, Ramona, Runwal Anthurium, LBS Marg, Mulund
West, Mumbai 400080, hereinafter referred to as the "StockAnts or Technology Platform".
The Parties to this Agreement are hereinafter individually referred to as the "Party" and collectively as the "Parties".
          </li>
        </ul>
        <p>Whereas:</p>
        <ul>
          <li>
            SEBI Experts, referred to SEBI Research Analysts (RAs) SEBI Registered Investment Advisors (RIAs), are individuals or entities registered with the Securities and Exchange Board of India (SEBI) as investment professionals. These experts provide investment advice, conduct research, and assist clients with investment decisions and portfolio management.
          </li>
          <li>
            StockAnts is a technology platform supporting SEBI Registered Intermediaries to help retail users for investment decision making & trade placement.
          </li>
          <li>
            SEBI Registered Intermediaries- SEBI Registered Intermediaries are entities or individuals registered with the Securities and Exchange Board of India (SEBI) as intermediaries to provide services in the securities market. SEBI intermediaries include various types of entities such as brokers, sub-brokers, investment advisors, portfolio managers, custodians, depositories, and other entities involved in the securities market.
          </li>
          <li>
            The Parties have agreed to execute this Agreement, for the servicing activities on the terms and conditions set forth in this Agreement.
          </li>
        </ul>
        <p class="font-weight-600">SEBI Expert Responsibility:</p>
        <ul>
          <li>
            The SEBI Expert has agreed to the terms and conditions of StockAnts at the time of onboarding and consent to sharing of their investment skills in form of recommendations, price estimates, model portfolios and support market insights in form chat with StockAnts and connected partners on an "as-is basis."
          </li>
          <li>
            SEBI Expert has mutual consent with StockAnts to display their information for organic visibility & investor awareness. SEBI Expert' information will be displayed on 'as is basis' along with StockAnts Brand.
          </li>
          <li>
            It is mandatory for the SEBI Expert has to share research reports and/ or rationale behind their recommendations.
          </li>
          <li>
            SEBI Expert's investment advice and recommendations on StockAnts are based on their independent analysis and judgement and are not influenced by any conflict of interest.
          </li>

          <li>
            SEBI Expert is responsible for the accuracy and completeness of all information and information provided to StockAnts. The Company reserves the right to remove or edit any content that is deemed inaccurate or inappropriate. The SEBI Expert confirms that the information is not derived by scraping or manipulating the market in any way
          </li>
          <li>
            SEBI Expert cannot share any insider information, confidential
            information, or privileged information on the StockAnts platform.
          </li>
          <li>
            SEBI Expert does not engage in any unethical conduct, front-running,
            or insider trading.
          </li>
        </ul>
      </div>
      <!-- Page 3 -->
      <div class="page">
        <ul>
          <li>
            The SEBI Expert acknowledges association with StockAnts as a
            technology platform to support retail users with investment decision
            making.
          </li>
          <li>
            SEBI Expert does not and cannot use StockAnts for any promotion or
            advertisement of their services/products.
          </li>
          <li>
            SEBI Expert certifies that all professional information provided on
            StockAnts, including their SEBI License, qualifications, company
            details, experience, and products served on StockAnts, are accurate
            and up to date.
          </li>
          <li>
            SEBI has not issued any penalties/directions under the SEBI Act or
            any other regulatory body in the name of SEBI Expert in the past.
          </li>
        </ul>

        <p class="font-weight-600">StockAnts Responsibilities/Rights:</p>
        <ul>
          <li>
            StockAnts displays price estimate/recommendations/model portfolios/chat support  from SEBI Expert only. StockAnts is a technology platform for SEBI Expert to showcase their investment skills in form of recommendations, price estimates, model portfolios and support market insights in form chat on an "as is basis".
          </li>
          <li>
            SEBI Expert's services/ recommendations/ products displayed can be restricted on StockAnts platform if the information is incorrect, incomplete or if it is misleading.
          </li>
          <li>
            StockAnts is a technology platform to support SEBI Registered Intermediaries to help retail users for investment decision making & trade placement.
          </li>
          <li>
            StockAnts reserves the right to cancel, restrict, or modify the status of any SEBI Expert's terms of this Agreement or the rewards plan at any time. The Company shall provide notice of 7 days in advance to the SEBI Expert but does not require to provide justification for any action taken.
          </li>
        </ul>

        <p class="font-weight-600">
          StockAnts Meets Compliance:
        </p>
        <ul>
          <li>
            StockAnts doesn't allow automation in the execution of trade, aIgo trading, social investing, stock market leagues, stock market gaming, copy trading, paper trading, or crypto. SEBI Expert's published information on StockAnts cannot be scrapped or fetched from the public domain for redistribution.
          </li>
          <li>
            StockAnts does not promote or allow giving tips on stocks/etf/indices and options. Information shared by SEBI experts is for educational purpose only.
          </li>
          <li>
            StockAnts does not give any rating and/ or ranking for the performance of the recommendations of the SEBI Expert.
          </li>
          <li>
            StockAnts displays price estimates from SEBI Expert only. StockAnts is a technology platform for SEBI Expert to showcase their recommendation and price estimates on an "as is basis".
          </li>
          <li>
            StockAnts will not make any change, addition, deletion or amend the information made available by the SEBI expert.
          </li>
          <li>
            StockAnts does not allow indicating or guaranteeing returns by SEBI Expert.
          </li>
          <li>
            StockAnts meets compliance requirements by maintaining client onboarding process of retail users.
          </li>
          <li>
            As a technology partner for SEBI expert, Automated reference number in SEBI expert name is generated for each client, to support as tech partner for SEBI Expert and retail user.
          </li>
        </ul>
      </div>
      <!-- Page 4 -->
      <div class="page">
        <p class="font-weight-600">
          SEBI Expert Compliance Maintained by StockAnts:
        </p>

        <ul>
          <li>
            StockAnts provides information of all connected partners &
            intermediaries where SEBI Expert detail/ information is displayed.
          </li>
          <li>
            As StockAnts is a technology partner for SEBI Expert, all details of
            retail user having access of SEBI Expert’s information of any kind &
            ‘as-is-basis’ is shared
          </li>
          <li>
            The SEBI Expert Association with StockAnts varies depending on their
            agreement.
          </li>
        </ul>

        <p class="font-weight-600">SEBI Expert Disclosure</p>

        <ul>
          <li>
            The information provided by SEBI Expert on StockAnts is for
            informational purposes only and should not be considered as
            personalized financial advice
          </li>
          <li>
            SEBI Expert sharing information on StockAnts is only the sample of
            expertise and for more information or support, retail user can reach
            SEBI Expert. SEBI Expert’s details are shared on SEBI Expert’s
            profile page.
          </li>
          <li>
            Past performance does not guarantee future returns and performances
            of the portfolios are subject to market risk
          </li>
          <li>
            Investment in securities involves inherent risks, and the performance of any investment can be influenced by various factors, including market conditions, economic trends, and company-specific events. Investor should understand that his/her investment decision is based on personal investment needs and risk tolerance, and information present in the material prepared by the company and on the website of the company is one among many other things that should be considered while making an investment decision.
          </li>
          <li>
            Registration granted by SEBI, in no way guarantee performance of the intermediary or provide any assurance of returns to investors.
          </li>
          <li>
            StockAnts or any SEBI Expert does not provide any promise or assurance of a favorable view for a particular industry, sector, or business group in any manner. Investors are requested to take into consideration all the risk factors, including their financial condition, suitability to risk return profile, and seek professional advice before investing.
          </li>
          <li>
            Disciplinary History: There are no outstanding litigations or no disciplinary history against the SEBI Expert.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import UserProfile from "@/components/UserProfile.vue";
import html2canvas from "html2canvas";
import PublisherCertificate from "./PublisherCertificate.vue";
import { serverAddr, serverHostName } from "../networkConfig";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { HelperNetworkCallBack } from "../mixins/Helper";

export default {
  name: "MyAccountSideBar",

  components: {
    UserProfile,
    PublisherCertificate,
  },
  mixins: [HelperNetworkCallBack],

  data() {
    return {
      isCollapsed: false,
      activeNames: ["1"],
      certificateData: null,
      hasPublisherPlan: false,
      downloadingDialogVisible: false,
      menu_list: [
        {
          title: "Membership",
          icon: require("../assets/images/membership.png"),
        },
        // {
        //   title: "Bank Details",
        //   icon: require("../assets/images/myAccount/bank_details.png"),
        // },
        {
          title: "Biling and Payments",
          icon: require("../assets/images/myAccount/payments.png"),
        },
        {
          title: "Support",
          icon: require("../assets/images/myAccount/support.png"),
        },
        {
          title: "FAQ",
          icon: require("../assets/images/myAccount/question.png"),
        },
        {
          title: "Change Password",
          icon: require("../assets/images/myAccount/password-recovery.png"),
        },
      ],
      userProfile: {},
      currentEnvironment: localStorage.getItem("currentEnvironment")
        ? JSON.parse(localStorage.getItem("currentEnvironment"))
        : {},

      summaryList: [],
      stockAntsLogo: "",
      isPdfDownloading: false,
    };
  },

  mounted() {
    this.stockAntsLogo = this.base64Logo();
    this.userProfile = JSON.parse(localStorage.getItem("profile"));
    if (this.userProfile.mark_as_verified_user) {
      var agreementObj = {
        title: "Agreement",
        icon: require("../assets/images/myAccount/Agreement Icon.svg"),
      };
      this.menu_list.splice(1, 0, agreementObj);
    }

    // if (this.userProfile && this.userProfile.utm_source == "Bigul") {
    //   this.$store.commit("commitMyAccountActiveState", "Support");
    //   this.menu_list = [
    //     {
    //       title: "Support",
    //       icon: require("../assets/images/myAccount/support.png"),
    //     },
    //     {
    //       title: "FAQ",
    //       icon: require("../assets/images/myAccount/question.png"),
    //     },
    //     {
    //       title: "Change Password",
    //       icon: require("../assets/images/myAccount/password-recovery.png"),
    //     },
    //   ];
    // }

    if (
      this.currentEnvironment &&
      this.currentEnvironment.loginModule == "BlinkX"
    ) {
      this.menu_list = this.menu_list.filter((item) => item.title !== "FAQ");
    }
    this.getCertificateData();
  },

  methods: {
    selectMenu(menu) {
      if (menu == "Agreement") {
        this.generatePdfForAgreement();
      } else {
        // stored active link in store
        if (this.$route.query.link) {
          //if current route has query params then on menu select removed it
          this.$router.replace("/my-account");
        }

        this.$store.commit("commitMyAccountActiveState", menu); //store my account page active state
        this.$store.commit("commitSupportPageActiveState", "NEW_TICKET"); //store support page active stage to by default show new ticket component

        // on menu select scroll page to top
        var elmnt = document.getElementsByClassName("MyAccount")[0];
        scrollTo(elmnt, 0, 100);
      }
    },
    async generatePdfForAgreement() {
      this.isPdfDownloading = true;
      this.downloadingDialogVisible = true;
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfContent = this.$refs.pdfContent;
      const pages = pdfContent.querySelectorAll(".page");
      const footerText =
        "TechVest LLP, 402, T3, Runwal Anthurium, L.B.S Marg, Mulund (west), Mumbai – 400080, Maharashtra, India."; // Customize your footer text

      for (let i = 0; i < pages.length; i++) {
        const canvas = await html2canvas(pages[i], {
          scale: 2,
        });
        const imgData = canvas.toDataURL("image/png");
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        if (i > 0) {
          pdf.addPage();
        }

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

        // Add top border for footer
        pdf.setDrawColor("#e72726");
        pdf.setLineWidth(0.5);
        pdf.line(
          10,
          pdf.internal.pageSize.getHeight() - 20,
          pdfWidth - 10,
          pdf.internal.pageSize.getHeight() - 20
        );

        // Add footer text
        pdf.setFontSize(10);
        pdf.text(
          footerText,
          pdfWidth / 2,
          pdf.internal.pageSize.getHeight() - 10,
          { align: "center" }
        );
      }

      pdf.save("master-service-agreement.pdf");
      this.isPdfDownloading = false;
      // this.downloadingDialogVisible = false;
    },
    getCertificateData() {
      serverAddr
        .get("/stockants_pro/get-transaction-history/")
        .then((response) => {
          const transaction = response.data.data.find(
            (trx) => trx.plan_name === "Publisher"
          );
          if (
            transaction &&
            transaction.publisher_certificate_data.length > 0
          ) {
            const data = transaction.publisher_certificate_data[0];
            this.certificateData = {
              is_eligible_for_download: data.is_eligible_for_download,
            };
            this.hasPublisherPlan = true;
          } else {
            this.certificateData = null;
            this.hasPublisherPlan = false;
          }
        })
        .catch((error) => {
          console.error("Error fetching transaction data:", error);
          this.certificateData = null;
          this.hasPublisherPlan = false;
        });
    },
    handleDownloadClick() {
      if (
        this.certificateData &&
        this.certificateData.is_eligible_for_download
      ) {
        this.downloadCertificate();
      } else {
        console.log("Certificate Download not available for 1st 30 days");
      }
    },

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },

    downloadCertificate() {
      const certificateElement = this.$refs.certificate.$refs.certificate;
      html2canvas(certificateElement)
        .then((canvas) => {
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = "certificate.png";
          link.click();
        })
        .catch((error) => {
          console.error("Error generating image:", error);
        });
    },
    handleChange(val) {
    },
  },

  computed: {
    //returns stored user profile from local storage
    // userProfile() {
    //   return JSON.parse(localStorage.getItem("profile"));
    // },

    // returns active state of my account section from store
    myAccountActiveState() {
      return this.$store.state.my_account_active_state;
    },
  },
};
</script>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

#pdf-content {
  position: absolute;
  top: -9999px;
  left: -9999px;
}
.pdf-style {
  .page {
    width: 210mm;
    height: 297mm;
    padding: 10mm 10mm;
    box-sizing: border-box;
    page-break-after: always;
  }

  .logo {
    width: 50mm;
    height: auto;
  }

  h1 {
    text-align: center;
    font-size: 16pt;
  }

  p,
  ul li {
    text-align: left;
    font-size: 9pt;
    padding: 2mm;
  }
}

.MyAccountSideBar {
  width: 265px;
  -webkit-box-shadow: 10px 0 10px -5px #d3d3d3;
  box-shadow: 10px 0 10px -5px #d3d3d3;
  position: fixed;
  height: 100%;
  overflow: auto;
  background-color: $filter-section-background-color;
  z-index: 3;
  .menu-item-list {
    margin: 40px 25px 0 25px;
    min-height: 370px;
    .title {
      font-size: 0.8rem;
      color: #9c9ca0;
      cursor: pointer;
      transition: 0s;
    }
    .title:hover {
      color: $secondary-theme-color;
      transition-delay: 0.1s;
    }
    .active-menu {
      color: $secondary-theme-color;
      font-weight: 600;
    }
  }
}
.collapse-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
}

.collapse-content p {
  margin: 0;
}

.collapse-content[style*="display: block"] {
  max-height: 100px; /* Adjust as needed */
  transition: max-height 0.1s ease-in;
}

.download-collapse-section {
  color: #505050;
  font-size: 10px;
  background-color: white;
  padding: 20px 10px;
  border-radius: 10px;
  margin-bottom: 100px;
}
.download-title {
  // margin: 30px 20px 30px 20px;
  border-radius: 10px;
  padding: 10px;
  text-align: center;
  background-color: #dbebff;
  color: #2d2e8d;
  width: 100%;
  margin-bottom: -10px;
}

.download-title .el-icon {
  margin-right: 5px;
}
.el-collapse-item__header .el-collapse-item__arrow {
  display: none;
}
.el-collapse-item__wrap {
  padding: 0px 0 0 0px;
}
</style>
